var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliceBackgroundArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 157,
    viewBox: "0 0 161 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.445 139.034C154.949 138.641 146.312 141.507 146.312 156.112M132 139.034C137.496 138.641 146.133 141.507 146.133 156.112",
    stroke: "#F15D2A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.999969C94 0.999969 146 64 146 149.5",
    stroke: "#F15D2A",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliceBackgroundArrow);
export default __webpack_public_path__ + "static/media/slice-background-arrow.bb4028bc3b0ec7bc88f90ae9cade4a48.svg";
export { ForwardRef as ReactComponent };